import React from 'react'
import { useUsers } from 'src/components/async/Users'
import { Assignee } from 'src/Utils/globalEnums'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { FilterDropdown } from '../FilterDropdown'

export const DashboardAssigneeFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element => {
  const { data: users } = useUsers()
  const noAssigneeValue = {
    value: Assignee.UNASSIGNED,
    label: Assignee.UNASSIGNED,
  }
  const filterValues = [
    noAssigneeValue,
    ...(users?.getUsersList().map((user) => ({
      label: user.getName() || user.getEmail(),
      value: user.getEmail(),
    })) || []),
  ]

  return (
    <FilterDropdown
      filterParam={FilterParam.DASHBOARD_ASSIGNEE}
      filterName={FilterName.DASHBOARD_ASSIGNEE}
      filterValues={filterValues}
      isNested={isNested}
    />
  )
}
